import styled from 'styled-components';
import { AiOutlineSelect } from 'react-icons/ai';
import { HiOutlineDocumentReport } from 'react-icons/hi';

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ContainerStyles = styled.div`
  position: relative;
  height: 34px;
  width: calc(90%);
  background-color: #eaeaea;
  border-radius: 3px;
  margin: 5px 25px;
  margin-bottom: ${({ isOpen, totalHeight }) =>
    (isOpen && totalHeight === 0 && '5px') ||
    (isOpen && totalHeight === 1 && '160px') ||
    (isOpen && totalHeight === 2 && '250px') ||
    (isOpen && totalHeight === 3 && '350px')};
`;

export const ProjectInfo = styled.div`
  height: 34px;
  display: flex;
  align-items: center;
  max-width: calc(80%);
  background-color: #eaeaea;
  border-radius: 3px;
`;

export const ProgressBar = styled.div`
  position: absolute;
  top: 0;
  height: 34px;
  width: ${({ completed }) => completed}%;
  background-color: ${({ completed }) =>
    completed > 0 ? '#378ef0' : '#eaeaea'};
  border-radius: ${({ completed }) =>
    completed > 98 ? 'inherit' : '3px 0 0 3px'};
  text-align: right;
  padding-left: 10px;
  opacity: 30%;
`;

export const IconDiv = styled.div`
  margin-left: 10px;
  margin-right: 15px;
  z-index: 5;
`;

export const TaskSide = styled.div`
  color: #323232;
  font-size: 14px;
  font-weight: bold;
  z-index: 5;
`;

export const PercentageAndDaysSide = styled.div`
  padding: 5px;
  color: #323232;
  font-size: 16px;

  box-shadow: 0 0 0 2px
    ${({ daysLeft }) => (daysLeft > 0 ? '#eaeaea' : '#c92c31')} inset;
  border-radius: 3px;
  display: flex;
  align-self: flex-start;
  width: 88px;
  margin-top: 5px;
`;

export const PercentageInfo = styled.div`
  font-size: 16px;
  color: #323232;
  width: calc(60%);
  text-align: right;
  padding-left: 2px;
`;

export const DaysInfo = styled.div`
  margin-left: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #323232;
  width: calc(40%);
  text-align: right;
  padding-right: 2px;
`;

export const BottomWrapper = styled.div``;

export const BottomDateDisplay = styled.div`
  color: #bcbcbc;
  font-size: 12px;
  padding-left: 25px;
  padding-top: 16px;
  display: flex;
  align-items: center;

  i {
    color: #e34850;
    font-weight: 300;
    font-size: 12px;
    margin-left: 5px;
  }
`;

export const BottomDetailsContainer = styled.div`
  height: ${({ height }) => height}px;
  box-shadow: 0 0 0 1px #eaeaea inset;
  border-radius: 0 0 3px 3px;
  width: calc(100%);
  position: absolute;
  top: 30px;
  display: flex;
  justify-content: space-between;
  padding-top: 35px;
  padding-bottom: 35px;
  margin-bottom: 5px;
  overflow: hidden;
`;

export const ColumnInfo = styled.section`
  margin: 10px 0;
  color: #323232;
  width: calc(100%);
  font-size: 12px;
`;

export const UpNextTasks = styled.div`
  width: calc(27%);
  padding-left: 25px;
`;

export const InProgressTasks = styled.div`
  width: calc(26%);
  border-right: 1px solid #eaeaea;
  border-left: 1px solid #eaeaea;
  padding-inline: 25px;
`;

export const InProgressAvatarAndPercentage = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;

  span {
    color: #8e8e8e;
    margin-top: 5px;
    font-weight: 300;
    font-size: 12px;
  }
`;

export const CompletedTasks = styled.div`
  width: calc(29%);
`;

export const TaskToDisplay = styled.p`
  max-height: ${({ column }) => (column === 'inProgress' ? '25px' : '45px')};
  width: calc(85%);
  margin-bottom: ${({ column }) => (column === 'inProgress' ? '' : '40px')};
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Avatar = styled.div`
  font-size: 8px;
  height: 19px;
  width: 19px;
  margin: 5px 5px 11px 0px;
  background-color: #8e8e8e;
  color: white;
  border-radius: 50%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Icon = styled(AiOutlineSelect)`
  margin-right: 7px;
  margin-left: 12px;
  transform: scaleX(-1);
  margin-top: 10px;
`;
export const ReportIcon = styled(HiOutlineDocumentReport)`
  margin-right: 7px;
  margin-left: 12px;
  transform: scaleX(-1);
  margin-top: 10px;
`;
